import { useEffect, useState } from 'react'
import Pagination from 'antd/lib/pagination'

import { TCustomPagination } from './CustomPagination.types'
import { isMobile } from 'react-device-detect'
import { SelectContainer, StyledSelect, StyledTotalCount } from './CustomPagination.styles'

const CustomPagination = ({ pageSize = 10, count, refetch, style }: TCustomPagination) => {
  const [activePage, setActivePage] = useState(1)
  const [perPage, setPerPage] = useState(pageSize)
  const [skip, setSkip] = useState(0)

  const onPageChange = (page: number) => {
    setActivePage(page)
    const skip = (page - 1) * perPage
    setSkip(skip)
    refetch({
      skip,
      limit: perPage,
    })
  }

  const itemRender = (_: unknown, type: string, originalElement: React.ReactNode) => {
    if (type === 'prev') {
      return <p className="antd-prev-next">Prev</p>
    }
    if (type === 'next') {
      return <p className="antd-prev-next">Next</p>
    }
    return originalElement
  }

  useEffect(() => {
    refetch({
      skip,
      limit: perPage,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perPage])

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <SelectContainer>
        <StyledSelect
          value={perPage}
          onChange={(e) => {
            setPerPage(Number(e.target.value))
          }}
        >
          {[10, 25, 50, 100, 200].map((n) => (
            <option key={n} value={n}>
              {n} rows per page
            </option>
          ))}
        </StyledSelect>
        <StyledTotalCount>Total count: {count}</StyledTotalCount>
      </SelectContainer>
      <Pagination
        size={isMobile ? 'small' : 'default'}
        current={activePage}
        total={Math.ceil(count)}
        showSizeChanger={false}
        pageSize={perPage}
        onChange={(page) => onPageChange(page)}
        itemRender={itemRender}
        style={style}
      />
    </div>
  )
}

export default CustomPagination
